import { ColumnDef } from "@tanstack/react-table";
import AdvanceTable from "components/base/AdvanceTable";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import Badge from "components/base/Badge";
import RevealDropdown, {
    RevealDropdownTrigger,
} from "components/base/RevealDropdown";
import { InutilizacaoTableType } from "data/inutilizacao";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

const downloadComprovante = async (empresaId: number, serie: number, id: number) => {
    try {
        const response = await axios.get(`/api/inutilizacao/${empresaId}/${serie}/${id}/comprovante`, {
            responseType: 'blob'
        });

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `comprovante-inutilizacao-${id}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Erro ao baixar comprovante:', error);
    }
};

export const inutilizacaoTableColumns: ColumnDef<InutilizacaoTableType>[] = [
    {
        accessorKey: "id",
        header: "ID",
        meta: {
            headerProps: { style: { width: 100 }, className: "ps-4" },
            cellProps: {
                className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
            },
        },
    },
    {
        accessorKey: "serie",
        header: "Série",
        meta: {
            headerProps: { style: { width: 120 }, className: "ps-4" },
            cellProps: {
                className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
            },
        },
    },
    {
        accessorKey: "tipoDocumento",
        header: "Tipo",
        cell: ({ row: { original } }) => {
            const { tipoDocumento } = original;
            // tipoDocumento pode vir como number (55, 65) do enum do backend
            const tipo = Number(tipoDocumento);
            switch (tipo) {
                case 55:
                    return <Badge variant="phoenix" bg="primary">NFe</Badge>;
                case 65:
                    return <Badge variant="phoenix" bg="success">NFCe</Badge>;
                default:
                    return <Badge variant="tag">{String(tipoDocumento)}</Badge>;
            }
        },
        meta: {
            headerProps: { style: { width: 100 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    },
    {
        accessorKey: "inicio",
        header: "Início",
        meta: {
            headerProps: { style: { width: 120 }, className: "ps-4" },
            cellProps: {
                className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
            },
        },
    },
    {
        accessorKey: "fim",
        header: "Fim",
        meta: {
            headerProps: { style: { width: 120 }, className: "ps-4" },
            cellProps: {
                className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
            },
        },
    },
    {
        accessorKey: "empresaNome",
        header: "Empresa",
        cell: ({ row: { original } }) => {
            const { empresaNome } = original;
            return <Badge variant="tag">{empresaNome}</Badge>;
        },
        meta: {
            headerProps: { style: { width: 200 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    },
    {
        accessorKey: "usuarioNome",
        header: "Usuário",
        meta: {
            headerProps: { style: { width: 150 }, className: "ps-4" },
            cellProps: {
                className: "fs-9 fw-semibold ps-4 text-body-tertiary text-opacity-85",
            },
        },
    },
    {
        accessorKey: "justificativa",
        header: "Justificativa",
        cell: ({ row: { original } }) => {
            const { justificativa } = original;
            return (
                <span
                    className="line-clamp-2"
                    title={justificativa}
                    style={{ maxWidth: "250px" }}
                >
                    {justificativa}
                </span>
            );
        },
        meta: {
            headerProps: { style: { width: 250 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    },
    {
        accessorKey: "createdAt",
        header: "Data",
        cell: ({ row: { original } }) => {
            const { createdAt } = original;
            return (
                <span className="fs-9 text-body-tertiary">
                    {formatDate(createdAt)}
                </span>
            );
        },
        meta: {
            headerProps: { style: { width: 140 }, className: "ps-4" },
            cellProps: { className: "ps-4" },
        },
    },
    {
        id: "action",
        cell: ({ row: { original } }) => (
            <RevealDropdownTrigger>
                <RevealDropdown>
                    <Dropdown.Item
                        onClick={() => downloadComprovante(original.empresaId, original.serie, original.id)}
                        className="d-flex align-items-center"
                    >
                        <FontAwesomeIcon icon={faFileDownload} className="me-2" />
                        Gerar Comprovante
                    </Dropdown.Item>
                </RevealDropdown>
            </RevealDropdownTrigger>
        ),
        meta: {
            headerProps: { style: { width: "7%" } },
            cellProps: { className: "text-end" },
        },
    },
];

const InutilizacaoTable = () => {
    return (
        <div>
            <AdvanceTable tableProps={{ className: "phoenix-table fs-9" }} />
            <AdvanceTableFooter pagination showViewAllBtn={false} />
        </div>
    );
};

export default InutilizacaoTable; 